<template>
	<div class="header">
    <div class="header_main">
        <div class="wrapper1">
            <div class="header_bg">
                <img src="../assets/img1/logo.png" >
                <div class="title">
                    <span class="title_cn">上海中小企业国际合作协会</span>
                    <!--                    <br>-->
                    <br>
                    <span class="title_en">Shanghai International Cooperation Association of Small and Medium Enterprises</span>
                </div>
            </div>
        </div>

    </div>
    <div class="nav">
        <div class="wrapper1">
            <el-menu
                    class="el-menu-demo"
                    mode="horizontal"
                    text-color="#fff"
                    background-color="#00008B"
                    active-text-color="#ffd04b"
            >
                <el-menu-item class="el-menu-item1" index="1" @click="$router.push('/MainPage')">首页</el-menu-item>
                <el-sub-menu class="el-sub-menu1" index="2" :popper-offset="8" >
                    <template #title>
                        <span class="title_menu">关于协会</span>
                    </template>
                    <el-menu-item class="item" index="1-1" @click="$router.push('/IntroductionPage')">协会简介</el-menu-item>
                    <el-menu-item class="item" index="1-2" @click="$router.push('/AssociationPurpose')" >协会宗旨</el-menu-item>
                    <el-menu-item class="item" index="1-3" @click="$router.push('/VisionAndMission')">协会愿景与使命</el-menu-item>
                    <el-menu-item class="item" index="1-4" @click="$router.push('/RulesPage')">协会章程</el-menu-item>
                    <el-menu-item class="item" index="1-5" @click="$router.push('/RegistrationPage')">登记事项</el-menu-item>
                    <el-menu-item class="item" index="1-6" @click="$router.push('/OrganizationPage')">组织架构</el-menu-item>
                    <el-menu-item class="item" index="1-7" @click="$router.push('/DirectorPage')">协会领导</el-menu-item>
                </el-sub-menu>
				<el-sub-menu class="el-sub-menu1" index="3">
					<template #title>
						<span class="title_menu">专题服务</span>
					</template>
					
					<el-menu-item 
						v-for="(dept, index) in departments" 
						:key="dept.id" 
						class="item" 
						:index="'2-' + (index + 1)" 
						@click="$router.push(`/dept/${dept.id}`)"
					>
						{{ dept.name }}
					</el-menu-item>
				</el-sub-menu>
                <el-sub-menu class="el-sub-menu1" index="4" :popper-offset="8">
                    <template #title>
                        <span class="title_menu">会员天地</span>
                    </template>
                    <el-menu-item class="item" index="3-1" @click="$router.push('/ConditionPage')">入会条件</el-menu-item>
                    <el-menu-item class="item" index="3-2" @click="$router.push('/XHMienPage')">会员风采</el-menu-item>
                    <el-menu-item class="item" index="3-3" @click="$router.push('/RegisterPage')">入会申请</el-menu-item>
                </el-sub-menu>
                <el-sub-menu class="el-sub-menu1" index="5" :popper-offset="8">
                <template #title>
                  <span class="title_menu">党建活动</span>
                </template>
                <el-menu-item class="item" index="4-1" @click="$router.push('/DJeduPage')">党建学习</el-menu-item>
                <el-menu-item class="item" index="4-2" @click="$router.push('/DJpublicize')">党建宣传活动</el-menu-item>
              </el-sub-menu>


            </el-menu>

        </div>

    </div></div>
</template>

<script>

import logo from "@/assets/img1/logo.png";
import { departments } from '@/config/menuConfig';


export default {
    name: "WebHeader",
    components:{


    },
    data(){
        return{
            logo: logo,
            qrCodeUrl: 'http://localhost:8080/test', // 指向本地开发服务器的地址
			departments: departments
        }
    }
}
</script>

<style scoped>
/* 直接引入外部 CSS */
@import "@/assets/css/header_combined.css";
</style>